// Lightweight multi-tenant PWA helpers: dynamic manifest + service worker + install prompt.
let deferredPrompt = null;
const listeners = new Set();

if (typeof window !== "undefined") {
  window.addEventListener("beforeinstallprompt", (e) => {
    e.preventDefault();
    deferredPrompt = e;
    listeners.forEach((fn) => fn(true));
  });
  window.addEventListener("appinstalled", () => {
    deferredPrompt = null;
    listeners.forEach((fn) => fn(false));
  });
}

// Point the page at a store/dashboard manifest, set theme colour, and register the SW.
export function enablePwa({ manifestUrl, themeColor }) {
  if (typeof document === "undefined") return;
  let link = document.querySelector('link[rel="manifest"]');
  if (!link) {
    link = document.createElement("link");
    link.rel = "manifest";
    document.head.appendChild(link);
  }
  link.href = manifestUrl;

  if (themeColor) {
    let tc = document.querySelector('meta[name="theme-color"]');
    if (!tc) {
      tc = document.createElement("meta");
      tc.name = "theme-color";
      document.head.appendChild(tc);
    }
    tc.content = themeColor;
  }

  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.register("/sw.js").catch(() => {});
  }
}

// Subscribe to install availability. Calls fn(true|false) immediately and on change.
export function onInstallAvailable(fn) {
  listeners.add(fn);
  fn(!!deferredPrompt);
  return () => listeners.delete(fn);
}

export async function promptInstall() {
  if (!deferredPrompt) return false;
  deferredPrompt.prompt();
  const choice = await deferredPrompt.userChoice;
  deferredPrompt = null;
  listeners.forEach((fn) => fn(false));
  return choice.outcome === "accepted";
}

export function isStandalone() {
  if (typeof window === "undefined") return false;
  return window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;
}
